/* @flow */
const prefix = str => `station/app/${str}`;

export const FETCH_SERVER_SESSION_TIMEOUT_SUCCESS = prefix('FETCH_SERVER_SESSION_TIMEOUT_SUCCESS');
export const SET_TIMEOUT_WARNING = prefix('SET_TIMEOUT_WARNING');

export const INITIALIZE = prefix('INITIALIZE');
export const INITIALIZE_SUCCESS = prefix('INITIALIZE_SUCCESS');

export const WARNING = prefix('WARNING');
export const SET_OPTIONS = prefix('SET_OPTIONS');
export const SET_THEME_FROM_PREFERENCES = prefix('SET_THEME_FROM_PREFERENCES');
export const SET_ACTIVITY = prefix('SET_ACTIVITY');
export const CONFIRMATION = prefix('CONFIRMATION');
export const SET_LAST_ROUTE = prefix('SET_LAST_ROUTE');

export const CONFIRM_ALIVE = prefix('CONFIRM_ALIVE');
export const CONFIRM_ALIVE_SUCCESS = prefix('CONFIRM_ALIVE_SUCCESS');

export const LOGIN = prefix('LOGIN');
export const LOGIN_SUCCESS = prefix('LOGIN_SUCCESS');
export const LOGIN_FAILURE = prefix('LOGIN_FAILURE');
export const LOGIN_REDIRECT = prefix('LOGIN_REDIRECT');
export const LOGIN_CLEAR_STATUS_MESSAGE = prefix('LOGIN_CLEAR_STATUS_MESSAGE');
export const LOGIN_CLEAR_STATUS_MESSAGE_SUCCESS = prefix('LOGIN_CLEAR_STATUS_MESSAGE_SUCCESS');
export const FORCE_LOGIN = prefix('FORCE_LOGIN');
export const DID_LOGIN_VIA_SSO = prefix('DID_LOGIN_VIA_SSO');

// This redirect action is for other TruSTAR frontend apps that use station-web-client for auth
export const LOGIN_REDIRECT_TO_EXTERNAL_APP = prefix('LOGIN_REDIRECT_TO_EXTERNAL_APP');

export const LOGOUT = prefix('LOGOUT');
export const LOGOUT_SUCCESS = prefix('LOGOUT_SUCCESS');
export const LOGOUT_FAILURE = prefix('LOGOUT_FAILURE');

export const USER_CREDENTIALS_UPDATE = prefix('USER_CREDENTIALS_UPDATE');
export const USER_CREDENTIALS_CLEAR = prefix('USER_CREDENTIALS_CLEAR');

export const MFA_VERIFY_RESPONSE = prefix('MFA_VERIFY_RESPONSE');
export const MFA_VERIFY_RESPONSE_SUCCESS = prefix('MFA_VERIFY_RESPONSE_SUCCESS');
export const MFA_VERIFY_RESPONSE_FAILURE = prefix('MFA_VERIFY_RESPONSE_FAILURE');
export const ACCEPT_TERMS = prefix('ACCEPT_TERMS');
export const ACCEPT_TERMS_SUCCESS = prefix('ACCEPT_TERMS_SUCCESS');
export const ACCEPT_TERMS_FAILURE = prefix('ACCEPT_TERMS_FAILURE');

export const DECLINE_TERMS = prefix('DECLINE_TERMS');

export const CHANGE_PASSWORD_CREDENTIALS_UPDATE = prefix('CHANGE_PASSWORD_CREDENTIALS_UPDATE');
export const CHANGE_PASSWORD_CLEAR = prefix('CHANGE_PASSWORD_CLEAR');
export const CHANGE_PASSWORD_VALIDATE = prefix('CHANGE_PASSWORD_VALIDATE');

export const CHANGE_PASSWORD = prefix('CHANGE_PASSWORD');
export const CHANGE_PASSWORD_SUCCESS = prefix('CHANGE_PASSWORD_SUCCESS');
export const CHANGE_PASSWORD_FAILURE = prefix('CHANGE_PASSWORD_FAILURE');
export const CHANGE_PASSWORD_FAILURE_BAD_LINK = prefix('CHANGE_PASSWORD_FAILURE_BAD_LINK');
export const CHANGE_PASSWORD_FAILURE_EXPIRED_TOKEN = prefix('CHANGE_PASSWORD_FAILURE_EXPIRED_TOKEN');

export const FORGOT_PASSWORD = prefix('FORGOT_PASSWORD');
export const FORGOT_PASSWORD_SUCCESS = prefix('FORGOT_PASSWORD_SUCCESS');
export const FORGOT_PASSWORD_FAILURE = prefix('FORGOT_PASSWORD_FAILURE');

export const CLIPBOARD_COPY = prefix('CLIPBOARD_COPY');


// WEBPACK FOOTER //
// ./src/app/modules/app/action-types.js